export const siteBrand = {
  name: '糖豆视频',
  tagline: '主播 · 网红女神专题合集',
  slogan: '网红女神小姐姐齐聚，精彩内容一网打尽',
};

export const heroKeywords = ['主播', '网红', '小姐姐', '女神', '直播', '达人'];

export const heroStats = [
  { value: '8,600+', label: '此刻在线主播' },
  { value: '12万+', label: '每日开播场次' },
  { value: '3,800万', label: '累计用户' },
];

export const tickerItems = [
  '苏晚晚 · 深夜电台 开播中',
  '白鹿儿 · 新编舞《霓虹》首发',
  '江晚吟 · 国风夜宴戏腔专场',
  '顾念 · 秋冬唇釉全试色',
  '林知夏 · 民谣点歌排队破千',
  '阿狸 · 新赛季上分实录',
  '温言 · 治愈系陶艺慢直播',
  '夏栀 · 陪你唠嗑到深夜',
];

export const liveTags = ['全部', '聊天', '音乐', '舞蹈', '美妆', '国风', '生活', '游戏'];

export const liveHosts = [
  {
    id: 'host-01',
    name: '苏晚晚',
    tag: '聊天',
    title: '深夜电台 · 温柔嗓音陪你入眠',
    summary: '今晚聊聊都市里的孤独与治愈，点歌、读信、说晚安。',
    viewers: '1.2万',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20gentle%20young%20asian%20woman%20singing%20at%20a%20warm-lit%20vintage%20radio%20microphone%20in%20a%20cozy%20studio%2C%20soft%20coral%20and%20amber%20lighting%2C%20dreamy%20bokeh%20background%2C%20film%20grain%2C%20high-end%20magazine%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=td-live-01&orientation=landscape',
  },
  {
    id: 'host-02',
    name: '林知夏',
    tag: '音乐',
    title: '吉他弹唱 · 民谣点歌专场',
    summary: '从《南山南》唱到《晚风》，你点的歌我都记得。',
    viewers: '8,634',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20young%20asian%20woman%20playing%20acoustic%20guitar%20on%20a%20small%20warm-lit%20stage%2C%20soft%20amber%20and%20coral%20glow%2C%20blurred%20concert%20bokeh%20background%2C%20film%20grain%2C%20high-end%20music%20magazine%20photography&width=800&height=500&seq=td-live-02&orientation=landscape',
  },
  {
    id: 'host-03',
    name: '白鹿儿',
    tag: '舞蹈',
    title: '颜值舞蹈 · 新编舞《霓虹》首发',
    summary: '镜面舞台超带感，今晚连续跳满三小时不重样。',
    viewers: '2.4万',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20photo%20of%20a%20graceful%20young%20asian%20dancer%20mid-pose%20with%20warm%20neon%20light%20trails%2C%20coral%20amber%20color%20palette%2C%20dark%20soft%20background%20bokeh%2C%20dynamic%20motion%2C%20high%20fashion%20magazine%20photography&width=800&height=500&seq=td-live-03&orientation=landscape',
  },
  {
    id: 'host-04',
    name: '顾念',
    tag: '美妆',
    title: '美妆试色 · 秋冬唇釉全试色',
    summary: '黄黑皮也能驾驭的雾面唇色，一支一支上嘴给你看。',
    viewers: '9,862',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20close-up%20of%20a%20young%20asian%20woman%20applying%20lipstick%20at%20a%20softly%20lit%20vanity%2C%20warm%20coral%20amber%20tones%2C%20blurred%20cosmetic%20bokeh%20background%2C%20film%20grain%2C%20beauty%20magazine%20photography&width=800&height=500&seq=td-live-04&orientation=landscape',
  },
  {
    id: 'host-05',
    name: '江晚吟',
    tag: '国风',
    title: '古风唱见 · 国风夜宴专场',
    summary: '一曲戏腔惊艳全场，汉服与古筝陪你度过东方夜。',
    viewers: '1.7万',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20young%20asian%20woman%20in%20elegant%20traditional%20hanfu%20singing%20on%20a%20stage%20with%20warm%20lantern%20light%2C%20coral%20amber%20palette%2C%20soft%20bokeh%20background%2C%20poetic%20magazine%20photography&width=800&height=500&seq=td-live-05&orientation=landscape',
  },
  {
    id: 'host-06',
    name: '夏栀',
    tag: '聊天',
    title: '元气聊天 · 陪你唠嗑到深夜',
    summary: '今天聊聊脱单那些事，弹幕刷起来一起出主意。',
    viewers: '6,420',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20cheerful%20young%20asian%20woman%20smiling%20while%20live%20chatting%20at%20home%2C%20warm%20cozy%20amber%20lamp%20light%2C%20softly%20blurred%20background%2C%20film%20grain%2C%20lifestyle%20magazine%20photography&width=800&height=500&seq=td-live-06&orientation=landscape',
  },
  {
    id: 'host-07',
    name: '温言',
    tag: '生活',
    title: '手作慢直播 · 治愈系陶艺',
    summary: '看一团泥土慢慢变成杯子，慢下来也是一种浪漫。',
    viewers: '4,312',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20photo%20of%20hands%20shaping%20clay%20on%20a%20pottery%20wheel%20in%20a%20warm%20sunlit%20studio%2C%20coral%20amber%20earthy%20tones%2C%20soft%20bokeh%20background%2C%20calm%20slow-life%20magazine%20photography&width=800&height=500&seq=td-live-07&orientation=landscape',
  },
  {
    id: 'host-08',
    name: '阿狸',
    tag: '游戏',
    title: '游戏开黑 · 新赛季上分实录',
    summary: '新赛季开局冲分，欢迎弹幕组队一起上分。',
    viewers: '1.1万',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20young%20asian%20woman%20streaming%20video%20games%20in%20a%20warm%20neon-lit%20room%2C%20coral%20amber%20and%20soft%20teal%20accent%2C%20blurred%20LED%20bokeh%20background%2C%20esports%20magazine%20photography&width=800&height=500&seq=td-live-08&orientation=landscape',
  },
];

export const collections = [
  {
    id: 'col-01',
    title: '深夜陪你入睡的女声',
    desc: '精选温柔声线，加班回家也能被治愈，每晚固定更新。',
    count: '12 位主播',
    fresh: '每晚更新',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20lay%20of%20a%20vintage%20microphone%20and%20warm%20headphones%20on%20a%20coral%20amber%20textured%20background%20with%20soft%20evening%20light%2C%20magazine%20cover%20style%2C%20film%20grain%2C%20cozy%20night%20radio%20mood&width=900&height=600&seq=td-col-01&orientation=landscape',
  },
  {
    id: 'col-02',
    title: '高颜值舞蹈合集',
    desc: '从流行编舞到国风舞台，一次看个够，天天都有新舞台。',
    count: '26 个专题',
    fresh: '每日上新',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20collage%20of%20dancers%20in%20motion%20with%20warm%20coral%20amber%20light%20streaks%20on%20a%20dark%20soft%20background%2C%20dynamic%20energy%2C%20high%20fashion%20magazine%20cover%20photography&width=900&height=600&seq=td-col-02&orientation=landscape',
  },
  {
    id: 'col-03',
    title: '国风音乐专场',
    desc: '戏腔、古筝、汉服，东方美学的声与影都在这里。',
    count: '18 个专题',
    fresh: '每周更新',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20traditional%20chinese%20guzheng%20and%20silk%20fan%20on%20a%20warm%20amber%20textured%20backdrop%2C%20elegant%20poetic%20mood%2C%20film%20grain%2C%20oriental%20magazine%20cover%20photography&width=900&height=600&seq=td-col-03&orientation=landscape',
  },
  {
    id: 'col-04',
    title: '美妆变美课堂',
    desc: '从新手入门到进阶妆容，主播真人实测一步步带你化。',
    count: '31 个专题',
    fresh: '实测向',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20lipsticks%20and%20makeup%20brushes%20arranged%20on%20a%20warm%20coral%20amber%20backdrop%20with%20soft%20light%2C%20beauty%20magazine%20cover%20photography%2C%20film%20grain&width=900&height=600&seq=td-col-04&orientation=landscape',
  },
  {
    id: 'col-05',
    title: '治愈系手作与慢生活',
    desc: '陶艺、花艺、烘焙，把普通日子慢慢过成诗。',
    count: '15 个专题',
    fresh: '慢节奏',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20handmade%20ceramic%20cups%20and%20dried%20flowers%20on%20a%20warm%20beige%20textured%20table%2C%20soft%20natural%20light%2C%20slow%20living%20magazine%20photography&width=900&height=600&seq=td-col-05&orientation=landscape',
  },
  {
    id: 'col-06',
    title: '游戏开黑搭子',
    desc: '找同频队友实时组队，上分路上不孤单。',
    count: '22 个专题',
    fresh: '实时组队',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20still%20life%20of%20a%20glowing%20game%20controller%20and%20headset%20on%20a%20warm%20coral%20amber%20desk%20setup%20with%20soft%20neon%20bokeh%2C%20esports%20magazine%20cover%20photography&width=900&height=600&seq=td-col-06&orientation=landscape',
  },
];

export const ranking = [
  { rank: 1, name: '苏晚晚', tag: '深夜电台', summary: '连续 30 天不间断开播，平均在线时长全网领先', score: '98.6' },
  { rank: 2, name: '白鹿儿', tag: '颜值舞蹈', summary: '单场涨粉破十万，编舞短视频全网播放量破亿', score: '96.3' },
  { rank: 3, name: '江晚吟', tag: '国风唱见', summary: '国风夜宴专场场均互动榜首，粉丝黏性极高', score: '94.8' },
  { rank: 4, name: '顾念', tag: '美妆达人', summary: '秋冬新品首发常驻嘉宾，口碑与转化双高', score: '92.1' },
  { rank: 5, name: '林知夏', tag: '音乐达人', summary: '民谣点歌互动率第一，点歌排队常常破千', score: '90.7' },
  { rank: 6, name: '阿狸', tag: '游戏达人', summary: '新赛季上分实录，组队邀请接单率最高', score: '89.4' },
  { rank: 7, name: '温言', tag: '手作生活', summary: '慢直播完播率突出，被粉丝称作电子布洛芬', score: '87.9' },
  { rank: 8, name: '夏栀', tag: '情感聊天', summary: '情感话题共鸣强，弹幕互动密度持续领先', score: '86.5' },
];

export const shorts = [
  {
    id: 'short-01',
    title: '3 分钟看完秋冬最显白唇色',
    tag: '美妆 · 顾念',
    views: '328万',
    duration: '03:12',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20portrait%20for%20a%20short%20video%20cover%20of%20a%20young%20asian%20woman%20with%20glossy%20lips%20holding%20lipstick%2C%20warm%20coral%20amber%20light%2C%20soft%20bokeh%2C%20beauty%20short%20video%20cover%2C%20film%20grain&width=600&height=800&seq=td-short-01&orientation=portrait',
  },
  {
    id: 'short-02',
    title: '这段国风编舞我能看一百遍',
    tag: '舞蹈 · 白鹿儿',
    views: '512万',
    duration: '01:48',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20photo%20of%20an%20asian%20dancer%20striking%20a%20dynamic%20pose%20with%20warm%20coral%20amber%20light%20trails%2C%20soft%20bokeh%2C%20short%20video%20cover%2C%20film%20grain&width=600&height=800&seq=td-short-02&orientation=portrait',
  },
  {
    id: 'short-03',
    title: '戏腔一起，鸡皮疙瘩起来了',
    tag: '国风 · 江晚吟',
    views: '441万',
    duration: '02:05',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20portrait%20of%20a%20young%20asian%20woman%20in%20hanfu%20singing%20with%20warm%20lantern%20light%2C%20coral%20amber%20palette%2C%20soft%20bokeh%2C%20short%20video%20cover&width=600&height=800&seq=td-short-03&orientation=portrait',
  },
  {
    id: 'short-04',
    title: '深夜电台：给加班的人一句晚安',
    tag: '聊天 · 苏晚晚',
    views: '276万',
    duration: '04:30',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20portrait%20of%20a%20gentle%20young%20asian%20woman%20speaking%20into%20a%20microphone%20in%20warm%20dim%20light%2C%20coral%20amber%20glow%2C%20soft%20bokeh%2C%20late%20night%20short%20video%20cover&width=600&height=800&seq=td-short-04&orientation=portrait',
  },
  {
    id: 'short-05',
    title: '陶艺里最治愈的十分钟',
    tag: '生活 · 温言',
    views: '189万',
    duration: '10:02',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20photo%20of%20hands%20shaping%20clay%20on%20a%20pottery%20wheel%20in%20warm%20sunlit%20studio%2C%20coral%20amber%20earthy%20tones%2C%20soft%20bokeh%2C%20short%20video%20cover&width=600&height=800&seq=td-short-05&orientation=portrait',
  },
  {
    id: 'short-06',
    title: '新赛季这套连招太丝滑了',
    tag: '游戏 · 阿狸',
    views: '233万',
    duration: '02:22',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20vertical%20editorial%20portrait%20of%20a%20young%20asian%20woman%20gaming%20with%20headphones%20in%20a%20warm%20neon-lit%20room%2C%20coral%20amber%20bokeh%2C%20short%20video%20cover%2C%20film%20grain&width=600&height=800&seq=td-short-06&orientation=portrait',
  },
];

export const categories = [
  { name: '歌舞才艺', count: '2,860 位主播', icon: 'ri-music-2-line' },
  { name: '深夜电台', count: '1,240 位主播', icon: 'ri-moon-clear-line' },
  { name: '国风音乐', count: '980 位主播', icon: 'ri-music-line' },
  { name: '美妆穿搭', count: '2,140 位主播', icon: 'ri-magic-line' },
  { name: '游戏电竞', count: '3,520 位主播', icon: 'ri-gamepad-line' },
  { name: '生活手作', count: '760 位主播', icon: 'ri-plant-line' },
  { name: '情感聊天', count: '1,980 位主播', icon: 'ri-chat-smile-2-line' },
  { name: '户外旅行', count: '640 位主播', icon: 'ri-roadster-line' },
  { name: '美食探店', count: '1,320 位主播', icon: 'ri-restaurant-2-line' },
  { name: '萌宠日常', count: '2,010 位主播', icon: 'ri-bear-smile-line' },
];

export const trustPillars = [
  { icon: 'ri-shield-user-line', title: '主播实名认证', desc: '开播前完成实名与人脸核验，身份真实可追溯。' },
  { icon: 'ri-eye-line', title: '内容双重审核', desc: '机审叠加人工巡检 7×24 小时，违规内容即时下线。' },
  { icon: 'ri-parent-line', title: '未成年人保护', desc: '青少年模式、消费提醒与观看时长管理一应俱全。' },
  { icon: 'ri-lock-2-line', title: '隐私与资金安全', desc: '支付全程加密，隐私最小化采集，异常登录实时预警。' },
];

export const trustStats = [
  { value: '45万+', label: '认证主播' },
  { value: '3,800万', label: '累计用户' },
  { value: '12万+', label: '每日开播' },
  { value: '7×24', label: '内容巡检' },
];

export const faqs = [
  {
    q: '糖豆视频可以免费观看吗？',
    a: '注册登录后即可免费进入直播间观看，主播的短视频也全部免费。部分专属互动与礼物属于按需消费，全程明示价格，绝无强制扣费。',
  },
  {
    q: '怎么关注喜欢的主播并收到开播提醒？',
    a: '进入主播主页点击「关注」，主播开播前你会收到站内与通知提醒。关注列表还可以按开播时间排序，再也不错过任何一场直播。',
  },
  {
    q: '短视频和直播内容是同步更新的吗？',
    a: '是的。主播直播中的高光片段会被实时剪辑成短视频，直播与短视频内容同步更新，让你一次看个够。',
  },
  {
    q: '平台对主播和内容有哪些审核机制？',
    a: '主播需完成实名认证方可开播，所有直播与短视频内容均经过机器审核与人工双重巡检，违规内容即时下线并按规定处理。',
  },
  {
    q: '未成年人使用有哪些保护措施？',
    a: '平台提供青少年模式、消费提醒与观看时长管理，家长可一键开启守护，限制打赏与直播时段，让浏览更安心。',
  },
  {
    q: '遇到不良内容或骚扰应该怎么办？',
    a: '直播与评论区均可一键举报，平台 7×24 小时受理，核实后快速处理并在站内反馈处理结果，你也可以直接拉黑对应的账号。',
  },
];